const setLanguage = (state, data) => {
  state.language = data.language
}
const setEliteModal = (state, data) => {
  state.eliteModal = data.eliteModal
}
export default {
  setLanguage,
  setEliteModal
}
